import { CreateHubDto, EditHubDto, HubDto, KnownCreateHubDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { HubSettingsForm } from './form';

export class HubSettingsFormOutput {
  name?: string;
  type?: KnownCreateHubDtoType;
  managedBy?: string;
  externalID?: string;
  externalShortID?: string;
  displayAddress?: string;
  openingHoursDisplay?: string;
  latitude?: number;
  longitude?: number;
  directions?: string;
  additionalDirections?: string;
  identificationNote?: string;

  constructor(form: HubSettingsForm) {
    if (form.name) this.name = form.name;
    if (form.type) this.type = form.type;
    if (form.managedBy) this.managedBy = form.managedBy;
    if (form.externalID) this.externalID = form.externalID;
    if (form.externalShortID) this.externalShortID = form.externalShortID;
    if (form.displayAddress) this.displayAddress = form.displayAddress;
    if (form.openingHoursDisplay) this.openingHoursDisplay = form.openingHoursDisplay;
    if (form.location?.latitude !== undefined) this.latitude = form.location.latitude;
    if (form.location?.longitude !== undefined) this.longitude = form.location.longitude;
    if (form.directions) this.directions = form.directions;
    if (form.additionalDirections) this.additionalDirections = form.additionalDirections;
    if (form.identificationNote) this.identificationNote = form.identificationNote;
  }

  static FromHubDto(hub: HubDto): HubSettingsForm {
    return {
      name: hub.name,
      type: hub.type as unknown as KnownCreateHubDtoType,
      managedBy: hub.managedByProjectID,
      externalID: hub.externalID,
      externalShortID: hub.externalShortID,
      displayAddress: hub.displayAddress,
      openingHoursDisplay: hub.openingHoursDisplay,
      location: hub.geolocation
        ? { latitude: hub.geolocation.latitude, longitude: hub.geolocation.longitude }
        : undefined,
      additionalDirections: hub.additionalDirections,
      directions: hub.directions,
      identificationNote: hub.identificationNote
    };
  }

  static ToEditHubDto(output: HubSettingsFormOutput): EditHubDto {
    const isExternalHub = output.type === KnownCreateHubDtoType.LockersHubExternal;
    return {
      name: output.name,
      ...(isExternalHub && {
        externalID: output.externalID,
        externalShortID: output.externalShortID,
        displayAddress: output.displayAddress,
        openingHoursDisplay: output.openingHoursDisplay
      }),
      geolocation:
        output.latitude !== undefined && output.longitude !== undefined
          ? { latitude: output.latitude, longitude: output.longitude }
          : undefined,
      directions: output.directions,
      additionalDirections: output.additionalDirections,
      identificationNote: output.identificationNote
    };
  }

  static ToCreateHubDto(output: HubSettingsFormOutput): CreateHubDto {
    const isExternalHub = output.type === KnownCreateHubDtoType.LockersHubExternal;
    return {
      name: output.name!,
      type: output.type!,
      managedByProjectID: output.managedBy!,
      ...(isExternalHub && {
        externalID: output.externalID,
        externalShortID: output.externalShortID,
        displayAddress: output.displayAddress,
        openingHoursDisplay: output.openingHoursDisplay
      }),
      geolocation: {
        latitude: output.latitude!,
        longitude: output.longitude!
      },
      directions: output.directions,
      additionalDirections: output.additionalDirections,
      identificationNote: output.identificationNote
    };
  }
}
